/**
 * Adaptador: liga o player de avatar do eia ao agendador COMPARTILHADO.
 *
 * O mapa de visemes, a cadência e a lógica de troca saíram daqui em 04/10/2026
 * e vivem em `modules/platform/app-shared/avatar/visemes.js`, consumidos também
 * pelo palco de aula da capacitação. Este arquivo ficou só com a borda: traduzir
 * os nomes canônicos (em português) para as chaves do acervo de fotos do eia,
 * que foram geradas em inglês por `extrair-acervo-de-boca` e não vale renomear.
 *
 * A API exportada é a mesma de antes, de propósito: `AvatarVisemePlayer.jsx`
 * não precisou mudar uma linha.
 *
 * ⚠️ `./visemes.js` é cópia obrigatória do canônico, byte a byte — o app é CRA
 * sem craco e o ModuleScopePlugin recusa import de fora de `src/`. Divergência
 * entre as duas cópias é pega pelo teste `avatar-visemes.test.mjs`.
 */
import { VISEME_POR_ID, BOCAS, EM_INGLES, CADENCIA, criarAgendador } from './visemes';

const emIngles = (nome) => EM_INGLES[nome] || EM_INGLES.fechada;

export const VISEME_ID_TO_NAME = Object.fromEntries(
  Object.entries(VISEME_POR_ID).map(([id, nome]) => [id, emIngles(nome)]),
);

export const VISEME_NAMES = BOCAS.map(emIngles);

export const MIN_HOLD_MS = CADENCIA.retencaoMinimaMs;
export const POLL_INTERVAL_MS = CADENCIA.intervaloMs;
export const CROSSFADE_MS = CADENCIA.crossfadeMs;

/**
 * Mesma assinatura de sempre: recebe o tempo do áudio em ms e avisa a cada
 * troca de boca, já com o nome em inglês que o acervo de fotos usa.
 */
export function createVisemeScheduler({ getCurrentTimeMs, visemes, onVisemeChange }) {
  const agendador = criarAgendador({
    tempoAtualMs: getCurrentTimeMs,
    visemes,
    aoTrocar: (nome) => onVisemeChange(emIngles(nome)),
  });
  return { start: agendador.comecar, stop: agendador.parar };
}
